import { Button } from '@material-ui/core';
import { useState } from 'react';
import en from '../../../lang/en-us';
import { UploadFile } from '../../../lib/UploadFile.tsx';
import { connect } from 'react-redux';
import { RootStateType } from '../../../redux-store/reducers';
import { useEffect } from 'react';
import { TableWithCollapse } from '../../../lib/DataTable';
import { useTableWithCollapse } from '../../../lib/DataTable/customHooks';
import { sendPhoneOTP, onSaveImageData } from '../../../redux-store/actions/nct';
import { OTP_ACTIONS, REGISTER_WITH_EMAIL } from '../../../utils/constants';
import NoFoliosFound from '../makeNct/NoFoliosFound';
import { TableColumn } from '../../../lib/DataTable/types';
import { ImageSaveType } from '../../../redux-store/types/nct';
import { ActionHeader } from '../makeNct';
import EmailRelationship from '../makeNct/ChangeEmail/EmailRelationship';
import MobileRelationship from '../makeNct/ChangeMobile/MobileRelationship';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { NFT_TRXN_TYPE_MAP } from '../commercial/utils';
import { PanSeedCheckNew } from '../../common/PanSeedCheckNew';
const { dashboard, common } = en;
export interface UNMATCHED_FOLIO_RESPONSE {
    amc: string;
    amcName: string;
    id?: number;
    maskedMobile: string;
    folio: number;
    isDemat?: 'N' | 'Y';
}

const initialValues = {
    emailRelationship: '',
    mobileRelationship: '',
};
const validationSchema = (userRegisteredWith: string) =>
    yup.object({
        emailRelationship:
            userRegisteredWith === 'EMAIL'
                ? yup.string().required(common.errors.relationship.emailRequired)
                : yup.string().notRequired(),
        mobileRelationship:
            userRegisteredWith === 'MOBILE'
                ? yup.string().required(common.errors.relationship.mobileRequired)
                : yup.string().notRequired(),
    });

function UnregisteredFolios(props: any) {
    const [rowData, setRowData] = useState<UNMATCHED_FOLIO_RESPONSE[]>([]);
    const [document, setDocument] = useState<any>({
        image: {
            name:
                props.userRegisteredWith === REGISTER_WITH_EMAIL ? 'EMAIL_CHANGE' : 'MOBILE_CHANGE',
            format: '',
            content: '',
        },
    });
    const fileName =
        props.userRegisteredWith === REGISTER_WITH_EMAIL
            ? 'Updation_of_Email_Id.docx'
            : 'Updation_of_Mobile_No.docx';

    const columns: TableColumn[] = [
        {
            field: 'id',
            headerName: 'FOLIO',
            width: 150,
        },
        {
            field: 'amcName',
            headerName: 'Fund House',
            width: 420,
        },
        {
            field: props.userRegisteredWith === 'EMAIL' ? 'maskedEmail' : 'maskedMobile',
            headerName: props.userRegisteredWith === 'EMAIL' ? 'EMAIL' : 'MOBILE NUMBER',
            width: 150,
        },
    ];

    const relationshipFormik = useFormik({
        initialValues,
        onSubmit: async ({ emailRelationship, mobileRelationship }) => {
            try {
                const { pan, pekrn, mobile, email } = props;
                let res = await props.sendPhoneOTP({
                    mobile,
                    pan,
                    pekrn,
                    action:
                        props.userRegisteredWith === 'EMAIL'
                            ? OTP_ACTIONS.UNREGISTERED_EMAIL_CHANGE
                            : OTP_ACTIONS.UNREGISTERED_MOBILE_CHANGE,
                });
                const routeStateParams = {
                    mobile,
                    ...(res || {}).body,
                    success: true,
                    // images: [document.image],
                    foliosToUpdate: selectedRows.map((fund) => ({
                        amc: fund.amc,
                        folio: fund.id,
                        ...(mobile ? { newMobile: mobile } : { newEmail: email }),
                        ...(mobile
                            ? { mobileRelationship: mobileRelationship }
                            : { emailRelationship: emailRelationship }),
                    })),
                    heading: dashboard.UnregisteredFolios.heading,
                    // fromUnregisteredFolio: true,
                    action:
                        props.userRegisteredWith === 'EMAIL'
                            ? OTP_ACTIONS.UNREGISTERED_EMAIL_CHANGE
                            : OTP_ACTIONS.UNREGISTERED_MOBILE_CHANGE,
                };
                props.history.push('unregistered-folios-otp', routeStateParams);
            } catch (err: any) {
                alert(err.message);
            }
        },
        validationSchema: validationSchema(props.userRegisteredWith),
    });

    const { tableColumns, tableRows, selectedRows, setSelectedRows } = useTableWithCollapse<
        UNMATCHED_FOLIO_RESPONSE[]
    >({
        rows: rowData,
        columns,
        // loading: !props?.unmatched.length,
    });
    const { unmatched = [] } = props;

    useEffect(() => {
        if (unmatched.length) {
            const { dematFunds = [], nonDematFunds = [] } = unmatched.reduce(
                (prev: any, curr: UNMATCHED_FOLIO_RESPONSE) => {
                    if (curr.isDemat === 'Y') {
                        return {
                            ...prev,
                            dematFunds: [...(prev.dematFunds ?? []), { ...curr, id: curr.folio }],
                        };
                    }
                    return {
                        ...prev,
                        nonDematFunds: [...(prev.nonDematFunds ?? []), { ...curr, id: curr.folio }],
                    };
                },
                [],
            );
            setRowData([...nonDematFunds, ...dematFunds]);
        }
    }, [unmatched]);

    const _handleImagesSelected = (value: any, format: any) => {
        setDocument({
            image: {
                ...document.image,
                format: format,
                content: value,
            },
        });
    };

    useEffect(() => {
        return () => {
            if (Object.values(document.image).every((_val) => !!_val)) {
                const imageInfo: ImageSaveType = {
                    data: [document.image],
                    type: 'UNREGISTERED_FOLIOS',
                };
                props.onSaveImageData(imageInfo);
            }
        };
    }, [document]);

    const checkIsDematFund = (row: UNMATCHED_FOLIO_RESPONSE) => {
        if (row.isDemat === 'Y') {
            return { selection: false, message: 'This folio not eligible for selection' };
        }
        return {
            selection: true,
            message: '',
        };
    };

    const [callPanSeed, setCallPanSeed] = useState(false);

    const resetTrigger = () => {
        setCallPanSeed(false);
    }

    return (
        <div className="curved-bg">
            <ActionHeader header={dashboard.UnregisteredFolios.heading} />
            {/* <h2 className="heading" style={{ marginBottom: '60px' }}>
                <a onClick={() => props.history.push('/portal/home')}>
                    <img src="/images/left-arrow-black.svg" alt="icon" />
                </a>
                {dashboard.UnregisteredFolios.heading}
            </h2> */}
            <PanSeedCheckNew
                foliosArray={selectedRows}
                callBackFn={relationshipFormik.handleSubmit as any}
                trxnType={NFT_TRXN_TYPE_MAP.unregisteredFolios}
                goBack={false}
                triggerCheck={callPanSeed}
                resetTrigger={resetTrigger}
            />
            <div className="curved-bg-content unregisterd-folios-content">
                <div className="curved-bg-content-table">
                    <p style={{ marginTop: '10px' }}>
                        {dashboard.UnregisteredFolios.tabs.newRequest.info1}
                        {props.userRegisteredWith === 'EMAIL' ? "email id's" : 'mobile numbers'}
                        {dashboard.UnregisteredFolios.tabs.newRequest.info2}
                    </p>
                    <div className="curved-bg-content-inner-top">
                        <div className="curved-table-content">
                            <div className="curved-table-content-bottom" style={{ width: '100%' }}>
                                {tableRows.length ? (
                                    <TableWithCollapse
                                        setSelectedRows={setSelectedRows}
                                        selectedRows={selectedRows}
                                        rows={tableRows.map((fund) => ({
                                            ...fund,
                                            isDisabled: fund.isDemat === 'Y',
                                        }))}
                                        columns={tableColumns}
                                        isRowSelectable={({ row }) =>
                                            checkIsDematFund(row).selection
                                        }
                                        toolTipTextGetter={({ row }) =>
                                            checkIsDematFund(row).message
                                        }
                                        checkBoxEnabled
                                        toolTipEnabled
                                    />
                                ) : (
                                    <NoFoliosFound />
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="curved-bg-content-inner-bottom">
                        {props.userRegisteredWith === 'EMAIL' ? (
                            <EmailRelationship emailFormik={relationshipFormik} />
                        ) : (
                            <MobileRelationship mobileFormik={relationshipFormik} />
                        )}
                        <h4>{dashboard.UnregisteredFolios.tabs.newRequest.uploadHeading}</h4>
                        <p>
                            {dashboard.UnregisteredFolios.tabs.newRequest.uploadInfo}
                            <span
                                className="upload-document-link"
                                // href={`${process.env.REACT_APP_S3_CLOUD_URL}/${fileName}`}
                                // target="_system"
                                onClick={
                                    () => {
                                        window.open(
                                            `${process.env.REACT_APP_S3_CLOUD_URL}/${fileName}`,
                                            '_system',
                                        );
                                    }
                                }
                                
                            >
                                {dashboard.UnregisteredFolios.tabs.newRequest.clickHere}
                            </span>
                            {dashboard.UnregisteredFolios.tabs.newRequest.toDownload}
                        </p>
                        <div className="unregistered-upload-btn">
                            <UploadFile
                                onImageSelected={_handleImagesSelected}
                                documentFormat="Document Format: .pdf/.png/.jpg"
                            />
                            <Button
                                disabled={!selectedRows.length || !document.image.content}
                                onClick={() => setCallPanSeed(true)}
                                className="customBtn"
                            >
                                {dashboard.changeEmail.buttonText}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(
    ({ authReducer, portfolio }: RootStateType) => ({ ...authReducer, ...portfolio }),
    { sendPhoneOTP, onSaveImageData },
)(UnregisteredFolios);
